import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';

@Component({
  selector: 'logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {
  isNewArrival: string;


  constructor(private authService: AuthService,public router: Router) {

  }

  ngOnInit() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/loading']);
  }//end ngOnInit

}//end class



